<div
  class="global-entity-selector"
  [class.global-entity-selector--picker-open]="isPickerOpen"
  aria-label="Global entity selector"
>
  <nv-box-button
    id="entity-selector-trigger"
    [text]="label"
    icon="dropdown-white"
    nvTooltip
    [tooltipData]="fullLabel"
    [isDisabled]="!isSwitcherActive"
    [iconAriaLabel]="isSwitcherActive ? 'Open picker' : 'Picker disabled'"
    (clickButton)="openPickerModal()"
  ></nv-box-button>
</div>
